import React from 'react'
import _, { isEmpty, isNull } from 'lodash'
import moment from 'moment-timezone'
import { RemoteTable, BrowserStorage } from 'camino-react'

import tabs from './Table/tabs'
import Columns from './Table/Columns'
import Header from './Table/Header'
import Filters from './Table/Filters'

import {
  cloudhelpExecute,
  cloudhelpGet,
  cloudhelpDelete
} from 'Utilities/CloudHelp'
import CopyModal from 'Components/Tables/Ticket/CopyModal'


class TicketTable extends React.Component {
  constructor (props) {
    super()

    const { ticketFilters } = props

    this.state = {
      loading: true,
      modalToDisplay: '',
      showCopyModal: false,
      savingStatus: 'Save',
      errors: [],
      message: '',
      customFilterUsers: [],
      loadingCustomFilters: false,
      customFiltersFields: {
        name: '',
        shared: false,
        id: null
      },
      customFilters: {
        ...ticketFilters
      },
      ticketsToAction: [],
      columns: []
    }
  }

  componentDidMount () {
    const { clients, employee } = this.props
    const sessionStorage = new BrowserStorage('sessionStorage')
    let allColumns = Columns({ clients, employee })
    const storagedColumns = sessionStorage.read('columns')

    if (!employee) allColumns = allColumns.filter(col => !col.employeeOnly)
    const columns = allColumns.map((column) => {
      if (isEmpty(storagedColumns) || (isNull(storagedColumns))) return column

      column.enabled = (storagedColumns.includes(column.accessor))
      return column
    })

    this.setState({ columns })
  }

  loadUsersForCustomFilters = () => {
    const { customFilters } = this.state
    const listOfCustomFiltersCreators = _.map(customFilters, customFilter => (customFilter.user_id))
    const postData = {
      user_ids: listOfCustomFiltersCreators
    }
    if (listOfCustomFiltersCreators) {
      cloudhelpGet('/api/users', postData)
        .then(({ data }) => {
          this.setState(() => ({
            customFilterUsers: data
          }))
        })
        .catch((error) => { console.log(error) })
    }
  }

  toggleShowCopyModal = (value) => {
    this.setState({ showCopyModal: value })
  }

  setModalToDisplay = (modal) => {
    this.loadUsersForCustomFilters()
    this.setState({
      modalToDisplay: modal,
      customFiltersFields: {
        name: '',
        shared: false,
        id: null
      }
    })
  }

  updateCustomFilterFields = (field, value) => {
    this.setState((prevState) => {
      const { customFiltersFields } = prevState

      const newCustomFiltersFields = Object.assign({}, customFiltersFields, { [field]: value })

      return {
        customFiltersFields: newCustomFiltersFields
      }
    })
  }

  submitCustomFilters = (filters) => {
    const { customFiltersFields } = this.state

    const { paths } = this.props
    const { customFiltersPath } = paths

    const method = customFiltersFields.id ? 'patch' : 'post'
    const submitPath = customFiltersFields.id ? customFiltersFields.path : customFiltersPath

    const postData = {
      custom_filter: {
        ...customFiltersFields,
        filters,
        custom_filterable_type: 'ticket'
      }
    }

    this.setState({
      errors: [],
      message: '',
      savingStatus: 'saving'
    })
    cloudhelpExecute(method, submitPath, postData)
      .then(({ data }) => {
        this.setState((prevState) => {
          const { customFilters } = prevState
          const newTicketFilter = Object.assign({}, data.ticketFilter, {
            filter_creator: true,
            path: data.path
          })

          const filteredcustomFilters = _.filter(
            customFilters, (customFilter, _index) => customFilter.id !== newTicketFilter.id
          )
          const newCustomFilters = [...filteredcustomFilters, newTicketFilter]
          return {
            customFilters: newCustomFilters,
            errors: [],
            message: '',
            savingStatus: 'save'
          }
        })

        this.setModalToDisplay('myCustomFilterModalVisible')
        window.location.reload()
      })
      .catch((error) => {
        const { response } = error
        this.setState({
          errors: response.data.errors,
          message: response.data.message,
          savingStatus: 'save'
        })
      })
  }

  destroyTicketFilters = (ticketFilter, indexToRemove) => {
    const { path } = ticketFilter
    this.setState({
      loadingCustomFilters: true
    })
    cloudhelpDelete(path)
      .then((response) => {
        this.setState((prevState) => {
          const { customFilters } = prevState

          const newcustomFilters = _.filter(
            customFilters, (_customFilter, index) => indexToRemove != index
          )

          return {
            customFilters: newcustomFilters,
            loadingCustomFilters: false
          }
        })
        this.setModalToDisplay('myCustomFilterModalVisible')
        window.location.reload()
      }).catch((error) => {
        const { response } = error
        this.setState({
          errors: response.data.errors,
          message: response.data.message,
          loadingCustomFilters: false
        })
      })
  }

  editTicketFilters = (ticketFilter) => {
    this.setModalToDisplay('customFilterFormVisible')
    const {
      name, shared, id, filters, path
    } = ticketFilter
    this.setState({
      customFiltersFields: {
        name,
        shared,
        id,
        path
      },
      filters
    })
  }

  attachCustomFilterHandlers (ticketFilters) {
    return (_.map(ticketFilters, (ticketFilter, index) => Object.assign({}, ticketFilter, {
      remove: () => this.destroyTicketFilters(ticketFilter, index),
      edit: () => this.editTicketFilters(ticketFilter)
    })))
  }

  loadFromRemoteData = (remoteData) => {
    const { rows } = remoteData
  }

  clientCellData (clientName, clientId) {
    if (_.isNil(clientName) && _.isNil(clientId)) {
      return ('No client set')
    }

    if (clientName && _.isNil(clientId)) {
      return clientName
    }

    return clientName
  }

  assigneeCellData (assignee) {
    if (_.isNil(assignee)) {
      return ('Not yet assigned')
    }

    return assignee
  }

  clientContactCellData (clientContactName, clientContactId) {
    if (_.isNil(clientContactName) && _.isNil(clientContactId)) {
      return ('No contact set')
    }

    return clientContactName
  }

  queueCellData = (queue) => {
    if (_.isNil(queue)) {
      return ('Not yet assigned')
    }

    return queue
  }

  updateTicketsToMerge = (event, row) => {
    const { ticketsToAction } = this.state
    const { target: { checked } } = event
    const {
      contact_name: ticketContact,
      title: ticketTitle,
      id: { value: ticketId },
      ticketMergePath,
      copyApiTicketPath,
      region,
      ticket_type
    } = row
    const ticketToMerge = {
      ticketId,
      ticketTitle,
      ticketContact,
      ticketMergePath,
      copyApiTicketPath,
      region,
      ticket_type
    }

    const prevTicketsToMerge = [...ticketsToAction]
    const newTicketsToMerge = checked ? (
      [...prevTicketsToMerge, ticketToMerge]
    ) : _.filter(
      prevTicketsToMerge, existingTicket => existingTicket.ticketId !== ticketToMerge.ticketId
    )

    this.setState({
      ticketsToAction: newTicketsToMerge
    })
  }

  handleColumn = (accessor) => {
    const { columns } = this.state

    const newColumns = columns.map((col) => {
      if (col.accessor === accessor) col.enabled = !col.enabled
      return col
    })

    const enabledColumns = newColumns.filter(col => col.enabled).map(col => col.accessor)

    const sessionStorage = new BrowserStorage('sessionStorage')
    sessionStorage.write('columns', enabledColumns)

    this.setState({ columns: newColumns })
  }

  render () {
    const {
      loading,
      modalToDisplay,
      customFiltersFields,
      customFilterUsers,
      loadingCustomFilters,
      errors,
      message,
      savingStatus,
      ticketsToAction,
      showCopyModal,
      columns
    } = this.state

    const {
      endpoint,
      employee,
      clients,
      contacts,
      queues,
      assignees,
      serviceCategories,
      localStoragePrefix,
      ticketFilters,
      regionStatusNames,
      paths,
      onHoldStatusesId,
      resolvedStatusesId,
      assigneesQueues,
      queuesAssignees,
      priorities,
      ticketTypes,
      tags,
      clientStatuses
    } = this.props

    const { bulkUpdatePath } = paths

    const {
      updateTicketsToMerge,
      setModalToDisplay,
      toggleShowCopyModal
    } = this

    const filters = Filters({
      assignees,
      clients,
      contacts,
      queues,
      regionStatusNames,
      serviceCategories,
      tags,
      clientStatuses
    })

    const filterOptions = employee ? filters : filters.filter(f => !f.employeeOnly)

    return (
      <>
        <CopyModal ticket={ticketsToAction[0]} show={showCopyModal} />

        <div className="camino">
          <RemoteTable
            {...this.props}
            storage={{
              filters: new BrowserStorage('sessionStorage'),
              tabs: new BrowserStorage('sessionStorage')
            }}
            loading={loading}
            tabs={tabs}
            defaultTabIndex={1}
            remoteEndpoint={endpoint}
            filterOptions={_.sortBy(filterOptions, 'label')}
            transformFilterOptions={() => filterOptions}
            noDataText="You currently have no tickets"
            localStoragePrefix={localStoragePrefix}
            onRemoteData={this.loadFromRemoteData}
            setModalToDisplay={setModalToDisplay}
            employee={employee}
            customFilterFormProps={{
              errors,
              message,
              savingStatus,
              submit: this.submitCustomFilters,
              customFiltersFields,
              updateCustomFilterFields: this.updateCustomFilterFields,
              showModal: modalToDisplay === 'customFilterFormVisible',
              removeModal: () => setModalToDisplay('')
            }}
            myCustomFiltersModalProps={{
              customFilterUsers,
              customFiltersFields,
              customFilters: this.attachCustomFilterHandlers(ticketFilters),
              showModal: modalToDisplay === 'customFiltersModalVisible',
              removeModal: () => setModalToDisplay(''),
              loadingCustomFilters
            }}
            mergeTicketsModalProps={{
              showModal: modalToDisplay === 'mergeTicketsModalVisible',
              removeModal: () => setModalToDisplay(''),
              ticketsToAction
            }}
            bulkUpdateTicketsModalProps={{
              showModal: modalToDisplay === 'bulkUpdateTickets',
              removeModal: () => setModalToDisplay(''),
              ticketsToUpdate: ticketsToAction,
              clients,
              assignees,
              regionStatusNames,
              bulkUpdatePath,
              onHoldStatusesId,
              resolvedStatusesId,
              assigneesQueues,
              queuesAssignees,
              queues,
              priorities,
              ticketTypes
            }}

            transformRows={remoteRows => {
              return _.map(remoteRows, row => Object.assign(
              {},
              row,
              {
                client_name: this.clientCellData(row.client_name, row.client_id),
                assignee_name: this.assigneeCellData(row.assignee_name),
                queue_name: this.queueCellData(row.queue_name),
                contact_name: this.clientContactCellData(row.contact_name, row.client_contact_id),
                onValue: () => updateTicketsToMerge(event, row)
              }
            ))}}
            transformColumns={() => columns.filter(col => col.enabled)}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            defaultPageSize={25}
            toggleShowCopyModal={val => toggleShowCopyModal(val)}
            ticketsToAction={ticketsToAction}
            HeaderComponent={Header}
            handleColumn={this.handleColumn}
            allColumns={columns}
          />
        </div>
      </>
    )
  }
}
Cell: row => (
  row.value ? moment(row.value).format('DD MMM YYYY, hh:mmA') : 'No correspondence'
),
TicketTable.defaultProps = {
  localStoragePrefix: 'TicketTable'
}

export default TicketTable
